import { useEffect, useState } from "react";

const GoogleMapsLoader = ({ apiKey, children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    // Skip if API is already loaded
    if (window.google && window.google.maps) {
      setIsLoaded(true);
      return;
    }

    // Skip if there's no API key
    if (!apiKey) {
      setHasError(true);
      console.error("Google Maps API key is missing");
      return;
    }

    // Create script element
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.id = "google-maps-script";

    // Set up event handlers
    script.addEventListener("load", () => {
      setIsLoaded(true);
    });

    script.addEventListener("error", () => {
      setHasError(true);
      console.error("Failed to load Google Maps API");
    });

    // Add script to document
    document.head.appendChild(script);

    // Cleanup
    return () => {
      // Only remove the script if we added it
      const existingScript = document.getElementById("google-maps-script");
      if (existingScript && existingScript === script) {
        document.head.removeChild(script);
      }
    };
  }, [apiKey]);

  if (hasError) {
    return (
      <div
        style={{
          padding: "20px",
          textAlign: "center",
          color: "#ff3333",
          backgroundColor: "#fff6f6",
          borderRadius: "4px",
          margin: "10px 0",
        }}
      >
        فشل في تحميل خرائط Google. يرجى التحقق من مفتاح API الخاص بك.
      </div>
    );
  }

  return children({ isLoaded });
};

export default GoogleMapsLoader;
